import React, { FC, useEffect, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { classNames } from '../utils';
import { markdown } from '../utils/markdown';

interface Props {
  className?: string;
  source?: string;
  span?: true;
}

export const RichMarkdownIt: FC<Props> = ({ source, span, className }) => {
  const history = useHistory();

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (!window.reactHistory) {
      // Create reactHistory to be able to safely change pages without reloading... Jeez
      window.reactHistory = (path) => {
        history.push(path);
      };
    }
  });

  // Let's avoid re-rendering the markdown over, and over, and over again.
  return useMemo(() => {
    if (!source) {
      return null;
    }

    const ElClass = span ? 'span' : 'div';
    return (
      <ElClass
        className={classNames({}, 'react-markdown', className ?? '')}
        dangerouslySetInnerHTML={{ __html: markdown(source) }}
      />
    );
  }, [source, span, className]);
};
